import { render } from "./VoteResults.vue?vue&type=template&id=7264354e&scoped=true"
import script from "./VoteResults.vue?vue&type=script&lang=js"
export * from "./VoteResults.vue?vue&type=script&lang=js"

import "./VoteResults.vue?vue&type=style&index=0&id=7264354e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7264354e"]])

export default __exports__